import { colors } from '../constants';
import { REGIONS } from '../constants/usersPage';

/**
 * Get user initials from name
 * @param {string} name - User's full name
 * @returns {string} First character of the name in uppercase
 */
export const getUserInitials = (name) => {
  if (!name) return '?';
  // Get the first character of the first word and convert to uppercase
  const firstChar = name.trim().charAt(0).toUpperCase();
  return firstChar;
};

/**
 * Get status color for display
 * @param {string} status - User status ('Active' or 'Inactive')
 * @returns {string} Color hex code
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'Active':
      return colors.success;
    case 'Inactive':
      return colors.textSecondary;
    default:
      return colors.textSecondary;
  }
};

/**
 * Get role color for display
 * @param {string} role - User role
 * @returns {string} Color hex code
 */
export const getRoleColor = (role) => {
  switch (role) {
    case 'Admin':
      return colors.error;
    case 'Chairperson':
      return colors.primary;
    case 'Responder':
      return colors.info;
    default:
      return colors.textSecondary;
  }
};

/**
 * Format user role for display
 * @param {string} role - User role value
 * @returns {string} Formatted role label
 */
export const formatUserRole = (role) => {
  if (!role) return 'N/A';
  return role.charAt(0).toUpperCase() + role.slice(1);
};

/**
 * Format user region for display
 * @param {string} region - User region value
 * @param {Array} regionsList - Optional regions list (defaults to REGIONS constant)
 * @returns {string} Formatted region label
 */
export const formatUserRegion = (region, regionsList = REGIONS) => {
  if (!region) return 'N/A';
  const regionOption = regionsList.find((r) => r.value === region);
  return regionOption ? regionOption.label : region;
};

